/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetProceduresResponseJson } from './get-procedures-response-json';
import { GetProceduresResult } from '../results/get-procedures-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { ProcedureDto } from '../models/procedure-dto';
import { ProcedureAddonDto } from '../models/procedure-addon-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetProceduresResponse extends ResponseWithErrorGeneric<GetProceduresResponseJson, GetProceduresResult> implements IResponseWithErrorGeneric<GetProceduresResult> {
  public procedures: ProcedureDto[];
  public procedureAddons: ProcedureAddonDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetProceduresResponse>) {
    super(response, GetProceduresResult.Error);
    if (this.result !== GetProceduresResult.Success) {
      return;
    }

    this.procedures = this.body.procedures ? this.body.procedures : [];
    this.procedureAddons = this.body.procedureAddons ? this.body.procedureAddons : [];
  }
  //</custom-body>
}
